export const EVENT_PROVIDER = {
  INTERNAL_CURATED: 'INTERNAL_CURATED',
  INTERNAL_AUTOMATED: 'INTERNAL_AUTOMATED',
  DATAMINR: 'DATAMINR',
};

export const EVENT_PROVIDER_DISPLAY_NAMES = {
  [EVENT_PROVIDER.INTERNAL_CURATED]: 'Crisis24',
  [EVENT_PROVIDER.INTERNAL_AUTOMATED]: 'Crisis24',
  [EVENT_PROVIDER.DATAMINR]: 'Dataminr',
};
